module.exports = __webpack_public_path__ + "img/somaliland.01603e6c.svg";